import moment from 'moment';
import { View, TextInput } from 'react-native';
import { types } from "../../redux/actionTypes";
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../commonComponents/activityIndicator/activityIndicator';

import { tdsActions } from './tdsRedux/tds.actions';
import { backgroundTdsArr, backgroundTdsArrBackPage } from './backgroundTdsArr';
import { navigateAction } from '../../helpers/navigationHelpers';
import { generalColorsTheme } from './../../constants/colorPallete';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import DatePickerComponent from '../../commonComponents/datepicker/DatePickerComponent';
import { TabHeader, Container, BoxShadow, TabsWrapper, Typography, TabBody, LineSaperator, AmountBox, CurrencyBox, InputBox, BlueBox, ButtonWrapper, RowContainer } from './style';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import getPlatformType from '../../helpers/getPlatform';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import { ODSInput } from '../../../openbrix-design-system/ui/atoms/ODSInput';
import { ODSIcon } from '../../../openbrix-design-system/ui/atoms/ODSIcon';
import ODSRadioButton from '../../../openbrix-design-system/ui/atoms/ODSRadioButton';

const custodialRepayment = (props) => {

  const dispatch = useDispatch();
  const [type, setType] = useState('web');
  const layoutType = getPlatformType();
  const {colors}=useTheme();
  const [tenancy, setTenancy] = useState({});
  const [status, setStatus] = useState('initiate');
  const [activeTab, setActiveTab] = useState('Tenants');
  const [agreedStatus, setAgreedStatus] = useState('agree');
  const [state, setState] = useState({ deposit_end_date: null });
  const [load, setLoad] = useState(false);
  const repaymentResponse = useSelector((state) => state.tds?.repaymentProposal);
  const createRepaymentSuccess = useSelector((state) => state.tds?.createRepaymentSuccess);

  useEffect(() => {
    setLoad(true)
    if(props.route.params.case_id == 0) {
      setStatus('initiate');
    }
    dispatch(tdsActions.getDepositRepaymentProposal(props.route.params.case_id, props?.route?.params?.tenancy_id, props?.route?.params?.dan));
  }, []);

  useEffect(() => { 
    if (createRepaymentSuccess) {
      setLoad(false);
      navigateAction(props.navigation, 'Custodial Dashboard', { 'tenancy_id': props?.route?.params?.tenancy_id, 'dan': props?.route?.params?.dan })
    }
  }, [createRepaymentSuccess]); 

  useEffect(() => {
    if(repaymentResponse) {
      setLoad(false)
      setTenancy(repaymentResponse.tenancy);
      const tenants = repaymentResponse?.tenancy?.tenants.map(tenant=>{
        return { ...tenant, repaymentAmount: 0, is_lead: tenant.tenant_classification == 'Lead Tenant'}
      })
      setState({ ...state, ...{tenants, amountToLandlord: 0 }});
    }
  }, [repaymentResponse]);

  const makeRepaymentRequest = () => {
    setLoad(true);

    let tenants = state.tenants;
    if( activeTab == 'Tenants') {
      tenants = tenants.filter(tenant=> tenant.is_lead)
    }

    const payload = {
      tenancy_id: props?.route?.params?.tenancy_id,
      amount_to_tenants: getTotalTenantAmount(),
      tenancy_end_date_tenant: moment(state.deposit_end_date).format('YYYY-MM-DD'),
      amount_to_agent_or_landlord: state.amountToLandlord ? parseFloat(state.amountToLandlord): state.amountToLandlord,
      repayments: tenants?.map((tenant)=> { return { id: tenant.line_item_id, repaymentAmount: parseFloat(tenant.repaymentAmount) } }),
    }
    dispatch(tdsActions.createDepositRepaymentProposal(payload));
  };

  const requestRepayment = () => {
    if(state.deposit_end_date){
      let reminder = 0
      if(activeTab == 'Tenant') {
        reminder = getReminderToAllocate1()
      } else {
        reminder = getReminderToAllocate()
      }
      let isDateInFuture = new Date() < state.deposit_end_date 
      if(reminder == 0 && !isDateInFuture) {
        setStatus('review');
      } else {
        let message = [];
        if(reminder > 0) {
          message.push('Full deposit amount must be allocated');
        } else if (reminder < 0) {
          message.push('You cannot repay more than the deposit amount');
        }
        if(isDateInFuture) {
          message.push('End date can not be in future');
        }
        dispatch({ type: types.SHOW_ALERT, alertType: "error", text: message.join(",") });
      }
    }else{
      dispatch({ type: types.SHOW_ALERT, alertType: "error", text:"Please select the date on which the tenancy ended" });
    }
 
  };

  const handleAmountToRepayChange = (tenant, value) => {
    const newTenants = state?.tenants?.map(obj => {
      if (obj.line_item_id === tenant.line_item_id) {
        return {...obj, repaymentAmount: value};
      }
      return obj;
    });
    setState({ ...state, tenants: newTenants })
  }

  const getTotalTenantAmount = () => {
    let totalAmount = 0;
    state.tenants?.map(tenant=>{
      if(tenant.repaymentAmount) {
        totalAmount += parseFloat(tenant.repaymentAmount)
      }
    });
    return totalAmount;
  }

  const getReminderToAllocate1 = () => {
    let totalAmount = parseFloat(state.amountToLandlord);
    state.tenants?.map(tenant=>{
      if(tenant.repaymentAmount && tenant.is_lead) {
        totalAmount += parseFloat(tenant.repaymentAmount)
      }
    })
    return parseFloat(tenancy?.tenancy?.deposit_amount) - totalAmount;
  };

  const getReminderToAllocate = () =>{
    let totalAmount = parseFloat(state.amountToLandlord);
    state.tenants?.map(tenant=>{
      if(tenant.repaymentAmount) {
        totalAmount += parseFloat(tenant.repaymentAmount)
      }
    })
    return parseFloat(tenancy?.tenancy?.deposit_amount) - totalAmount;
  };

  const renderDepositSection = () => {
    return (
      <View>
        <Typography 
        id={"TOTAL_DEPOSIT_HELD"}
        color={'#194592'} size={'25px'} bold={400}>
          Total Deposit Held
        </Typography>
        <ODSText type='h2' marginBottom={32} marginTop={16} textAlign='center' color='#001A96'>£ {tenancy?.tenancy?.deposit_amount}</ODSText>
        <LineSaperator />
        <View style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',alignItems:'center',marginTop:32,marginBottom:48}}>
         <View>
          <ODSText textAlign={layoutType=='phone' &&  'center'} color='#001A96' type='sm-bold'>Tenancy end date</ODSText>
          <ODSText color={colors.text.secondary} marginTop={6} type='sm'>{status == 'initiate' ?'Please select the date on which the tenancy ended':'Supplied by tenant'}</ODSText>
          </View>
          <View>
          <DatePickerComponent
            key="datepicker"
            id={"TDS-TENANCY-ENDDATE"}
            placeholderText="select a date"
            inputLabel={{ fontSize: 16, color: '#000', fontWeight: 'bold' }}
            value={state?.deposit_end_date}
            disabled={status == 'review' }
            onUpdateInput={(date) => {
              setState({...state, deposit_end_date: date });
            }}
          />

          </View>

         </View>
      </View>
    );
  };

  const renderRepaymentSection = () => {
    return (
      <View style={{marginBottom:48}} >
        <ODSText color='#001A96' textAlign='center' type='h6'>Repayment options</ODSText>
       <ODSText textAlign='center' color={colors.text.secondary} type='sm' marginTop={8}>
        {`Please request repayment of the deposit below. You can either request repayment of the deposit in full to the lead tenant, or split the deposit between the tenant(s) and landlord using the 'custom' tab.`}
       </ODSText>
      </View>
    );
  };

  const renderReSection = () => {
    return (
      <View style={{ width: '100%', padding: 43 }}>

        {state.tenants?.map((otherTenant,index) => {
          return (
            <View key={index} style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',alignItems:'center',marginTop:32,marginBottom:48}}>
            <View style={{flex:0.65}}>
             <ODSText textAlign={layoutType=='phone' &&  'center'} color='#001A96' type='sm-bold'>Amount of deposit to be repaid to tenant</ODSText>
             <ODSText color={colors.text.secondary} marginTop={6} type='sm'>{otherTenant?.fullname}</ODSText>
             </View>
             <View style={{flex:0.35}}>
             <ODSInput
               renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
               label=''
               id={"TDS-REPAYMENT-AMOUNT"+index} 
               keyboardType='numeric'
                    value={otherTenant.repaymentAmount}
                    onChange={(value) => {
                      // Only allow numeric input with decimal point
                      const numericValue = value.replace(/[^0-9.]/g, '');
                      // Prevent multiple decimal points
                      const parts = numericValue.split('.');
                      const formattedValue = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');
                      handleAmountToRepayChange(otherTenant, formattedValue)
                    }}
               />
             </View>
            </View>
          //   <View
          //   key={index}
          //   style={{ flexDirection: 'row', marginTop: 50 }}>
          //   <View style={{ flexDirection: 'column', flex: 0.7 }}>
          //     <Typography align={'left'} color={'#194592'} size={'23px'} bold={700}>
          //       Amount of deposit to be repaid to tenant
          //     </Typography>
          //     <Typography top={'16px'} align={'left'} color={'#000000'} size={'20px'} bold={500}>
          //       {otherTenant?.fullname}
          //     </Typography>
          //   </View>
          //   <View
          //     style={{
          //       flexDirection: 'column',
          //       flex: 0.3,
          //       alignItems: 'center',
          //       justifyContent: 'center',
          //     }}
          //   >
          //     <AmountBox>
          //       <CurrencyBox>
          //         <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
          //           £
          //         </Typography>
          //       </CurrencyBox>
          //       <InputBox>
          //         <TextInput
          //           style={{
          //             margin: 8,
          //             padding: 6,
          //             width: '96%',
          //             height: '100%',
          //             borderWidth: 0,
          //           }}
          //           placeholder=""
          //           keyboardType="numeric"
          //           id={"TDS-REPAYMENT-AMOUNT"+index}
          //           value={otherTenant.repaymentAmount}
          //           onChangeText={(value) => {
          //             handleAmountToRepayChange(otherTenant, value)
          //           }}
          //         />
          //       </InputBox>
          //     </AmountBox>
          //   </View>
          // </View>  
          )
        })}

         <View style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',alignItems:'center',marginTop:16,marginBottom:48}}>
            <View style={{flex:0.65}}>
             <ODSText textAlign={layoutType=='phone' &&  'center'} color='#001A96' type='sm-bold'>Amount of deposit to be repaid to landlord</ODSText>
             <ODSText color={colors.text.secondary} marginTop={6} type='sm'>{tenancy?.property?.membername}</ODSText>
             </View>
             <View style={{flex:0.35}}>
             <ODSInput
               renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
               label=''
               id={"TDS-REPAYMENT-AMOUNT"} 
               keyboardType='numeric'
               value={state.amountToLandlord}
               onChange={(value) => {
                const numericValue = value.replace(/[^0-9.]/g, '');
                const parts = numericValue.split('.');
                const formattedValue = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');
                setState({...state, amountToLandlord: formattedValue });
              }}
               />
             </View>
            </View>

        {/* <View style={{ flexDirection: 'row', marginTop: 50 }}>
          <View style={{ flexDirection: 'column', flex: 0.7 }}>
            <Typography align={'left'} color={'#194592'} size={'23px'} bold={700}>
              Amount of deposit to be repaid to landlord
            </Typography>
            <Typography top={'16px'} align={'left'} color={'#000000'} size={'20px'} bold={500}>
              {tenancy?.property?.membername}
            </Typography>
          </View>
          <View
            style={{
              flexDirection: 'column',
              flex: 0.3,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{
                    margin: 8,
                    padding: 6,
                    width: '96%',
                    height: '100%',
                    borderWidth: 0,
                    color:state.amountToLandlord< 0? "red":'black'
                  }}
                  placeholder=""
                  keyboardType="numeric"
                  value={state.amountToLandlord}
                  id={"TDS-REPAYMENT-LANDLORDAMOUNT"}
                  onChangeText={(value) => {
                    setState({...state, amountToLandlord: value });
                  }}
                />
              </InputBox>
            </AmountBox>
          </View>
        </View> */}

{/* <ODSText color='#001A96' textAlign='right' marginTop={24}  type='md'>Remainder to allocate: £{getReminderToAllocate()?getReminderToAllocate():''} </ODSText> */}
<View style={{flexDirection:'row',marginTop:24,alignItems:'center',alignSelf:'flex-end'}}>
<ODSText color='#001A96' textAlign='right' type='md-bold' >Remainder to allocate: </ODSText>
   <ODSText 
     color={getReminderToAllocate() > 0 ? '#000000' : getReminderToAllocate() < 0 ? '#FF0000' : '#000000'} 
     textAlign='right' 
     type='md-bold' 
   >
     £{getReminderToAllocate() !== null && getReminderToAllocate() !== undefined ? getReminderToAllocate() : 0}
   </ODSText>
</View>

        {/* <BlueBox>
        <View style={{flex:0.65}}>
          <Typography align={'left'} color={'#FFFFFF'} size={'24px'} bold={500}>
            Remainder to allocate
          </Typography>
          </View>
          <View style={{flex:0.35}}>
          <AmountBox height={'42px'}>
            <CurrencyBox color="#FFFFFF">
              <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                £
              </Typography>
            </CurrencyBox>
            <InputBox>
              <TextInput
                style={{
                  margin: 8,
                  padding: 6,
                  width: '96%',
                  height: '100%',
                  borderWidth: 0,
                  color:  getReminderToAllocate() <0 ?"red":"black"
                }}
                placeholder=""
                keyboardType="numeric"
                id={"TDS-REPAYMENT-REMAINDERALLOCATE"}
                value={ getReminderToAllocate() }
                onChangeText={() => {}}
              />
            </InputBox>
          </AmountBox>
          </View>
        </BlueBox> */}
       
      </View>
    );
  };

  const renderTeanantSection = () => {
    return (
      <View style={{ width: '100%', padding: 20 }}>
        {state.tenants?.map((otherTenant,index) => {
          return (
            <>
          { otherTenant?.is_lead
            ? 
            <View key={index} style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',alignItems:'center',marginTop:32,marginBottom:48}}>
            <View style={{flex:0.65}}>
             <ODSText textAlign={layoutType=='phone' &&  'center'} color='#001A96' type='sm-bold'>Amount of deposit to be repaid to lead tenant</ODSText>
             <ODSText color={colors.text.secondary} marginTop={6} type='sm'>{otherTenant?.fullname}</ODSText>
             </View>
             <View style={{flex:0.35}}>
             <ODSInput
               renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
               label=''
               id={"TDS-REPAYMENT-AMOUNT"+index} 
               keyboardType='numeric'
               value={otherTenant.repaymentAmount}
               onChange={(value) => {
                // Only allow numeric input with decimal point
                const numericValue = value.replace(/[^0-9.]/g, '');
                // Prevent multiple decimal points
                const parts = numericValue.split('.');
                const formattedValue = parts[0] + (parts.length > 1 ? '.' + parts[1] : '');
                handleAmountToRepayChange(otherTenant, formattedValue)
              }}
               />
             </View>
            </View>
              // <View
              // key={index}
              // style={{ flexDirection: 'row', mar }}>
              //   <View style={{ flexDirection: 'column', flex: 0.7 }}>
              //     <Typography align={'left'} color={'#194592'} size={'23px'} bold={700}>
              //       Amount of deposit to be repaid to tenant
              //     </Typography>
              //     <Typography top={'16px'} align={'left'} color={'#000000'} size={'20px'} bold={500}>
              //       {otherTenant?.fullname}
              //     </Typography>
              //   </View>
              //   <View
              //     style={{
              //       flexDirection: 'column',
              //       flex: 0.3,
              //       alignItems: 'center',
              //       justifyContent: 'center',
              //     }}
              //   >
              //     <AmountBox>
              //       <CurrencyBox>
              //         <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
              //           £
              //         </Typography>
              //       </CurrencyBox>
              //       <InputBox>
              //         <TextInput
              //           style={{
              //             margin: 8,
              //             padding: 6,
              //             width: '96%',
              //             height: '100%',
              //             borderWidth: 0,
              //           }}
              //           placeholder=""
              //           id={"TDS-REPAYMENT-AMOUNT"+index} 
              //           keyboardType="numeric"
              //           value={otherTenant.repaymentAmount}
              //           onChangeText={(value) => {
              //             handleAmountToRepayChange(otherTenant, value)
              //           }}
              //         />
              //       </InputBox>
              //     </AmountBox>
              //   </View>
              // </View>  
            :
            null
          }</>
          )
        })}
<View style={{flexDirection:'row',marginTop:24,alignItems:'center',alignSelf:'flex-end'}}>
<ODSText color='#001A96' textAlign='right' type='md-bold' >Remainder to allocate: </ODSText>
   <ODSText 
     color={getReminderToAllocate1() > 0 ? '#000000' : getReminderToAllocate1() < 0 ? '#FF0000' : '#000000'} 
     textAlign='right' 
     type='md-bold' 
   >
     £{getReminderToAllocate1() !== null && getReminderToAllocate1() !== undefined ? getReminderToAllocate1() : 0}
   </ODSText>
</View>
             
        {/* <BlueBox>
          <View style={{flex:0.65}}>
          <Typography align={'left'} color={'#FFFFFF'} size={'24px'} bold={500}>
            Remainder to allocate
          </Typography>
          </View>
          <View style={{flex:0.35}}>
          <AmountBox height={'42px'}>
            <CurrencyBox color="#FFFFFF">
              <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                £
              </Typography>
            </CurrencyBox>
            <InputBox>
              <TextInput
                style={{
                  margin: 8,
                  padding: 6,
                  width: '96%',
                  height: '100%',
                  borderWidth: 0,
                  color:getReminderToAllocate1()< 0? "red":'black'
                }}
                id={"TDS-REPAYMENT-REMAINDERALLOCATE"} 
                placeholder=""
                keyboardType="numeric"
                value={ getReminderToAllocate1() }
                onChangeText={() => {}}
              />
            </InputBox>
          </AmountBox>
          </View>
        </BlueBox> */}
       
      </View>
    );
  };

  const renderDetailsTabs = () => {
    return (
      <TabsWrapper>
        <View
          style={{
            flexDirection: 'row',
            width: '100%',
            height: 70,
            borderBottomWidth: 1,
            borderBottomColor: generalColorsTheme.active,
          }}
        >
          <TabHeader
            onPress={() => {
              setActiveTab('Tenants');
              let newTenants = state?.tenants && state.tenants.map((tenant)=>{
                if(!tenant.is_lead) {
                  return { ...tenant, repaymentAmount: 0 }
                } else {
                  return tenant
                }
              })
              setState({...state, tenants: newTenants, amountToLandlord: 0})
            }}
            id={"TDS-TAB-LEADTEANANT"}
          >
            <Typography
              color={
                activeTab === 'Tenants' ? generalColorsTheme.active : generalColorsTheme.inactive
              }
              size={'23px'}
              bold={700}
            >
              Lead Tenant
            </Typography>
          </TabHeader>
          <TabHeader 
          id={"TDS-TAB-CREPAYMENT"} 
          hideBoderLeft onPress={() => setActiveTab('Repayment')}>
            <Typography
              color={
                activeTab === 'Repayment' ? generalColorsTheme.active : generalColorsTheme.inactive
              }
              size={'23px'}
              bold={700}
            >
              Custom Repayment
            </Typography>
          </TabHeader>
        </View>
        <TabBody>
          {activeTab === 'Tenants' ? renderTeanantSection() : null}
          {activeTab === 'Repayment' ? renderReSection() : null}
        </TabBody>
      </TabsWrapper>
    );
  };

  const renderPreviewSection = () => {
    return (
      <View>
        <Typography bottom={'3px'} align={'left'} color={'#194592'} size={'20px'} bold={700}>
          Repayment to Tenants
        </Typography>
        <RowContainer>
          <View style={{ flex: 0.6 }}></View>
          <View style={{ flex: 0.4 }}>
            <Typography bottom={'33px'} align={'left'} color={'#000000'} size={'16px'} bold={700}>
              Tenant Request
            </Typography>
          </View>
        </RowContainer>

        {state?.tenants?.map(tenant=>{
          return(
          <RowContainer>
          <View style={{ flexDirection: 'column', flex: 0.6, justifyContent: 'center' }}>
            <Typography align={'left'} color={'#000000'} size={'20px'} bold={500}>
              {tenant.fullname}
            </Typography>
          </View>
          <View style={{ flexDirection: 'column', flex: 0.4, justifyContent: 'center' }}>
          <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            value={tenant.repaymentAmount}
            
            />
            {/* <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{ margin: 8, padding: 6, width: '96%', height: '100%', borderWidth: 0 }}
                  placeholder=""
                  keyboardType="numeric"
                  value={tenant.repaymentAmount}
                />
              </InputBox>
            </AmountBox> */}
          </View>
        </RowContainer>)
        })}
        <RowContainer style={{ marginTop: 20 }}>
          <View style={{ flexDirection: 'column', flex: 0.6, justifyContent: 'center' }}>
            <Typography align={'left'} color={'#194592'} size={'20px'} bold={500}>
              Total
            </Typography>
          </View>
          <View style={{ flexDirection: 'column', flex: 0.4, justifyContent: 'center' }}>
            {/* <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{ margin: 8, padding: 6, width: '96%', height: '100%', borderWidth: 0 }}
                  placeholder=""
                  keyboardType="numeric"
                  value={getTotalTenantAmount()}
                />
              </InputBox>
            </AmountBox> */}
             <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            value={getTotalTenantAmount()}
            
            />
          </View>
        </RowContainer>
        <Typography
          top={'40px'}
          bottom={'3px'}
          align={'left'}
          color={'#194592'}
          size={'20px'}
          bold={700}
        >
          Repayment to Landlord
        </Typography>
        <RowContainer>
          <View style={{ flex: 0.6 }}></View>
          <View style={{ flex: 0.4 }}>
            <Typography bottom={'33px'} align={'left'} color={'#000000'} size={'16px'} bold={700}>
              Tenant Request
            </Typography>
          </View>
        </RowContainer>
        <RowContainer>
          <View style={{ flexDirection: 'column', flex: 0.6, justifyContent: 'center' }}>
            <Typography align={'left'} color={'#000000'} size={'20px'} bold={500}>
              {tenancy?.property?.membername}
            </Typography>
          </View>
          <View
            style={{
              flexDirection: 'column',
              flex: 0.4,
              justifyContent: 'center',
            }}
          >
            {/* <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{
                    margin: 8,
                    padding: 6,
                    width: '96%',
                    height: '100%',
                    borderWidth: 0,
                  }}
                  placeholder=""
                  keyboardType="numeric"
                  value={state.amountToLandlord}
                />
              </InputBox>
            </AmountBox> */}
             <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            value={state.amountToLandlord}
            
            />
            
          </View>
        </RowContainer>
        <RowContainer style={{ marginTop: 20 }}>
          <View style={{ flexDirection: 'column', flex: 0.6, justifyContent: 'center' }}>
            <Typography align={'left'} color={'#194592'} size={'20px'} bold={500}>
              Total
            </Typography>
          </View>
          <View
            style={{
              flexDirection: 'column',
              flex: 0.4,
              justifyContent: 'center',
            }}
          >
            {/* <AmountBox>
              <CurrencyBox>
                <Typography align={'left'} color={'#4C664B'} size={'20px'} bold={500}>
                  £
                </Typography>
              </CurrencyBox>
              <InputBox>
                <TextInput
                  style={{
                    margin: 8,
                    padding: 6,
                    width: '96%',
                    height: '100%',
                    borderWidth: 0,
                  }}
                  placeholder=""
                  keyboardType="numeric"
                  value={state.amountToLandlord}
                />
              </InputBox>
            </AmountBox> */}
             <ODSInput
            renderLeftIcon={<ODSIcon icon='TB-Euro' size={16} />}
            // label='Deposit Amount'
            editable={false}
            value={state.amountToLandlord}
            
            />
          </View>
        </RowContainer>

        {status == 'review' ? (
          <>
           <ODSText type='h6' marginTop={48} color='#001A96'>Declaration</ODSText>
        <Typography align="left" top={'8px'} bottom={'20px'} color={'#000000'} size={'18px'} bold={500}> 
        {`I consent to TDS copying this form and any supporting documents to the other party(ies) to the tenancy; to the appointed adjudicator if necessary, and to anyone else involved in resolving a dispute about the deposit.

I achknowledge that i have read and agree to be bound by the TDS rules.`}
        </Typography> 
        <View style={{gap:20}}>
        <ODSRadioButton
          label={'I agree with the statement above'}
          checked={agreedStatus == 'agree'?true:false}
          onPress={() => {
            setAgreedStatus('agree');
          }}
          color={'#001A96'}
        />
          <ODSRadioButton
          label={'I dont agree with the repayment request and wish to change the amount each tenant receives '}
          checked={agreedStatus == 'dont_agree'?true:false}
          onPress={() => {
            setAgreedStatus('dont_agree');
          }}
          color={'#001A96'}
        />
        </View>
           
          </>
        ) : null}

        <View style={{flexDirection:layoutType=="phone"?'column':'row',justifyContent:'space-between',marginTop:48,gap:20}}>
          <ODSButton
          type={'secondary'}
          onPress={() => { setStatus('initiate') }}
          restStyle={{height:44,borderColor:'#FF41C0',borderWidth:1}}
          >
            Cancel
          </ODSButton>
          <ODSButton
          disabled={agreedStatus !== 'agree'}
           onPress={() => {
            makeRepaymentRequest();
          }}
          restStyle={{height:44,backgroundColor:agreedStatus !== 'agree'?'grey' :'#FF41C0'}}
          >
            Submit
          </ODSButton>

        </View>

        {/* <ButtonWrapper
          top={'75px'}
          disabled={agreedStatus == 'agree' ? false : true}
          onPress={() => {
            makeRepaymentRequest();
          }}
        >
          <Typography color={'#FFFFFF'} size={'19px'} bold={800}>
            {status == 'review' ? 'SUBMIT' : 'OK'}
          </Typography>
        </ButtonWrapper>

        {status == 'review' ? 
          <ButtonWrapper top={'75px'} onPress={() => { setStatus('initiate') }}>
            <Typography color={'#FFFFFF'} size={'19px'} bold={800}>
              CANCEL
            </Typography>
          </ButtonWrapper>
        : null } */}
      </View>
    );
  };

  return (
    <>
      <BackGroundGenerator
        isTds
        props={props}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        infoIcon
        paddingtop={80}
        redirectTDSAccount={()=> { navigateAction(props.navigation, 'Custodial Account') }}
        tdsAccountIcon
        backgroundArr={backgroundTdsArrBackPage}
        isBack={true}
        backNavigation={()=> props?.navigation?.goBack() }
      >
        <Container>
         <BoxShadow padding={layoutType && '30px'} bottom={'40px'} >
            {renderDepositSection()}
            {status == 'initiate' ? renderRepaymentSection() : null}
            {status == 'initiate' ? renderDetailsTabs() : renderPreviewSection()}
           {status=='initiate' && <ODSButton
            lIcon={'TB-Arrow-Right'}
            id={"TDS-REQUEST-REPAYMENT"}
             onPress={() => {
              requestRepayment();
            }}
            restStyle={{alignSelf: 'flex-end', height:44,backgroundColor:'#FF41C0',marginBottom: 16, marginTop: 16 }}
            >
              Continue
            </ODSButton>}
       
            </BoxShadow>
        </Container>
      </BackGroundGenerator>
      <Loader loading={load} />
    </>
  );
};

export default custodialRepayment;
